/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

// HttpClient lives in ../base/generated; import it to avoid duplicating infrastructure.
import { ContentType, HttpClient, type RequestParams } from "../base/generated";

export class CustomApi<SecurityDataType> extends HttpClient<SecurityDataType> {
	api = {
		/**
		 * @description Allocate a new disposable mailbox; optional JSON body for ttl, local_part, mail_domain. Schedules expiry cleanup when the queue client is configured.
		 *
		 * @tags custom
		 * @name DisposableAliasesCreate
		 * @summary Create disposable alias
		 * @request POST:/api/disposable/aliases
		 */
		disposableAliasesCreate: (
			body: ControllersCreateDisposableAliasBody,
			params: RequestParams = {},
		) =>
			this.request<ConstantsGenericResponse, ConstantsGenericResponse>({
				path: `/api/disposable/aliases`,
				method: "POST",
				body: body,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Inbound hosts from configuration that clients may pass as mail_domain when creating an alias
		 *
		 * @tags custom
		 * @name DisposableDomainsList
		 * @summary List disposable mail domains
		 * @request GET:/api/disposable/domains
		 */
		disposableDomainsList: (params: RequestParams = {}) =>
			this.request<ConstantsGenericResponse, ConstantsGenericResponse>({
				path: `/api/disposable/domains`,
				method: "GET",
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Returns not_found, destroyed, or active status for a local-part (no auth)
		 *
		 * @tags custom
		 * @name DisposableLookupList
		 * @summary Lookup disposable alias
		 * @request GET:/api/disposable/lookup
		 */
		disposableLookupList: (
			query: {
				/** Mailbox local-part */
				local_part: string;
			},
			params: RequestParams = {},
		) =>
			this.request<ConstantsGenericResponse, ConstantsGenericResponse>({
				path: `/api/disposable/lookup`,
				method: "GET",
				query: query,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Paginated messages for an alias; inactive aliases return empty messages with status not_found or destroyed
		 *
		 * @tags custom
		 * @name DisposableMessagesList
		 * @summary List disposable inbox messages
		 * @request GET:/api/disposable/messages
		 */
		disposableMessagesList: (
			query: {
				/** Mailbox local-part */
				local_part: string;
				/** Page (default 1) */
				page?: number;
				/** Page size (default 25, capped by server) */
				limit?: number;
				/** Search substring (subject/from) */
				q?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<ConstantsGenericResponse, ConstantsGenericResponse>({
				path: `/api/disposable/messages`,
				method: "GET",
				query: query,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Submit abuse or takedown request for operator review (no auth)
		 *
		 * @tags custom
		 * @name DisposableReportCreate
		 * @summary Report disposable abuse
		 * @request POST:/api/disposable/report
		 */
		disposableReportCreate: (
			body: ControllersReportDisposableBody,
			params: RequestParams = {},
		) =>
			this.request<ConstantsGenericResponse, ConstantsGenericResponse>({
				path: `/api/disposable/report`,
				method: "POST",
				body: body,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Aggregate counters for marketing: aliases_created, messages_received, domains_offered
		 *
		 * @tags custom
		 * @name DisposableStatsList
		 * @summary Disposable public stats
		 * @request GET:/api/disposable/stats
		 */
		disposableStatsList: (params: RequestParams = {}) =>
			this.request<ConstantsGenericResponse, ConstantsGenericResponse>({
				path: `/api/disposable/stats`,
				method: "GET",
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Receives parsed inbound mail JSON from InboundParse (Basic auth).
		 *
		 * @tags custom
		 * @name InboundEmailCreate
		 * @summary InboundParse email webhook
		 * @request POST:/api/inbound/email
		 */
		inboundEmailCreate: (params: RequestParams = {}) =>
			this.request<Record<string, any>, Record<string, any>>({
				path: `/api/inbound/email`,
				method: "POST",
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * @description Returns a placeholder widget response — replace with real logic
		 *
		 * @tags custom
		 * @name WidgetsList
		 * @summary Example widget endpoint
		 * @request GET:/api/widgets
		 */
		widgetsList: (params: RequestParams = {}) =>
			this.request<any, any>({
				path: `/api/widgets`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
}
